import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import IconSvg from 'ui/shared/IconSvg';
import NavigationMobile from 'ui/snippets/navigation/mobile/NavigationMobile';
import TestnetBadge from 'ui/snippets/navigation/TestnetBadge';
import NetworkMenuButton from 'ui/snippets/networkMenu/NetworkMenuButton';
import NetworkMenuContentMobile from 'ui/snippets/networkMenu/NetworkMenuContentMobile';
import useNetworkMenu from 'ui/snippets/networkMenu/useNetworkMenu';

interface BurgerButtonProps {
  isOpen: boolean;
  onToggle: () => void;
}

export const BurgerButton = ({ isOpen, onToggle }: BurgerButtonProps) => {
  const iconColor = useColorModeValue('gray.400', 'white');
  const borderColor = useColorModeValue('gray.300', 'gray.600');

  return (
    <Box
      paddingX={ 1 }
      paddingY={ 1 }
      onClick={ onToggle }
      border="1px solid"
      borderColor={ borderColor }
      borderRadius="6px"
      cursor="pointer"
      _focus={{ outline: 'none' }}
      _focusVisible={{ outline: 'none', boxShadow: 'none' }}
      aria-expanded={ isOpen }
      aria-label="Menu button"
    >
      <IconSvg
        name="burger"
        boxSize={ 6 }
        display="block"
        color={ iconColor }
      />
    </Box>
  );
};

interface BurgerDropdownContentProps {
  onClose: () => void;
  isMarketplaceAppPage?: boolean;
}

export const BurgerDropdownContent = ({ onClose, isMarketplaceAppPage }: BurgerDropdownContentProps) => {
  const networkMenu = useNetworkMenu();

  const handleNetworkMenuButtonClick = React.useCallback(() => {
    networkMenu.onToggle();
  }, [ networkMenu ]);

  return (
    <>
      <TestnetBadge alignSelf="flex-start"/>
      { config.UI.navigation.featuredNetworks && (
        <Flex alignItems="center" justifyContent="flex-end" mb={ 2 }>
          <NetworkMenuButton
            isMobile
            isActive={ networkMenu.isOpen }
            onClick={ handleNetworkMenuButtonClick }
          />
        </Flex>
      ) }
      { networkMenu.isOpen ?
        <NetworkMenuContentMobile tabs={ networkMenu.availableTabs } items={ networkMenu.data }/> :
        <NavigationMobile onNavLinkClick={ onClose } isMarketplaceAppPage={ isMarketplaceAppPage }/>
      }
    </>
  );
};

interface BurgerProps {
  isOpen: boolean;
  onToggle: () => void;
  isMarketplaceAppPage?: boolean;
}

const Burger = ({ isOpen, onToggle, isMarketplaceAppPage }: BurgerProps) => (
  <BurgerButton isOpen={ isOpen } onToggle={ onToggle }/>
);

export default Burger;
